// import { IBreadcrumb } from '@/base-ui/breadcrumb'
import { RouteRecordRaw } from 'vue-router'
import { RouterVo } from '@/api/vo/user-vo'
import localCache from '@/utils/cache'

export function mapMenusToRoutes(userMenus: RouterVo[]): RouteRecordRaw[] {
  const routes: RouteRecordRaw[] = []

  let firstMenu = localCache.getCache('firstMenu')
  // 根据菜单获取需要添加的routes
  const _recurseGetRoute = (menus: RouterVo[]) => {
    for (const menu of menus) {
      if (menu.component && menu.path && menu.menuType === 'C') {
        // 直接使用menu的component属性创建路由配置
        const route: RouteRecordRaw = {
          path: menu.path,
          name: menu.name,
          component: () => import(`@/views/admin/${menu.component}.vue`),
          meta: {
            title: menu.meta?.title,
            icon: menu.meta?.icon
          },
          children: []
        }

        routes.push(route)

        // 记录第一个菜单作为默认路由
        if (!firstMenu) {
          firstMenu = menu
          localCache.setCache('firstMenu', firstMenu)
        }
      }
      // 递归处理子菜单
      if (menu.children && menu.children.length > 0) {
        _recurseGetRoute(menu.children)
      }
    }
  }
  _recurseGetRoute(userMenus)

  return routes
}

/*export function mapMenusToRoutes2(userMenus: RouterVo[]): RouteRecordRaw[] {
  const routes: RouteRecordRaw[] = []

  // 1.先去加载默认所有的routes
  const allRoutes: RouteRecordRaw[] = []
  const routeFiles = require.context('../router/system', true, /\.ts/)
  routeFiles.keys().forEach((key) => {
    const route = require('../router/system' + key.split('.')[1])
    allRoutes.push(route.default)
  })

  // 2.根据菜单获取需要添加的routes
  // userMenus:
  // type === 1 -> children -> type === 1
  // type === 2 -> url -> route
  const _recurseGetRoute = (menus: RouterVo[]) => {
    //debugger
    for (const menu of menus) {
      if (menu.menuType === 'C') {
        const path = menu.path
        const route = allRoutes.find((route) => route.path === path)
        if (route) routes.push(route)
        if (!firstMenu) {
          firstMenu = menu
        }
      } else {
        if (menu.children && menu.children.length > 0) {
          _recurseGetRoute(menu?.children)
        }
      }
    }
  }

  _recurseGetRoute(userMenus)

  return routes
}*/

/**
 * 将路径映射到菜单
 * @param menus 菜单列表
 * @param currentPath 当前路径
 * @returns 映射到的菜单
 */
export function pathMapToMenu(menus: RouterVo[], currentPath: string): RouterVo | null {
  for (const menu of menus) {
    const menuPath = menu.path
    if (menuPath === currentPath) {
      return menu
    }
    if (menu.children && menu.children.length > 0) {
      const found = pathMapToMenu(menu.children, currentPath)
      if (found) return found
    }
  }
  return null
}

/**
 * 将路径映射到菜单及其父菜单（用于展开父级目录）
 * @param menus 菜单列表
 * @param currentPath 当前路径（不含 query，用于匹配 menu.path）
 * @param parent 父级菜单（递归时传入）
 * @returns { menu, parent } 匹配的菜单及其父级目录
 */
export function pathMapToMenuWithParent(
  menus: RouterVo[],
  currentPath: string,
  parent: RouterVo | null = null
): { menu: RouterVo | null; parent: RouterVo | null } {
  for (const menu of menus) {
    if (menu.path === currentPath) {
      return { menu, parent }
    }
    if (menu.children && menu.children.length > 0) {
      const found = pathMapToMenuWithParent(menu.children, currentPath, menu)
      if (found.menu) return found
    }
  }
  return { menu: null, parent: null }
}
